<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <div>
            Order Discounts Enabled:
            <v-icon
              left
              color="success"
              v-if="$store.getters.retrieveOrderDiscountsEnabled == '1'"
            >
              check_circle_outline
            </v-icon>
            <v-icon left color="error" v-else>cancel</v-icon>

            <v-btn outlined color="deep-purple base" v-on="on">
              <span>Change</span>
            </v-btn>
          </div>
        </template>

        <v-card :loading="$store.getters.orderdiscountsLoading">
          <v-card-title>
            <h4>Change Order Discounts Enabled</h4>
            <v-spacer></v-spacer>
            <v-btn icon color text @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-switch
              :loading="$store.getters.orderdiscountsLoading"
              @change="setFlag()"
              v-model="orders_discounts_flag"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                <div>
                  Order Discounts Enabled:
                  <v-icon
                    left
                    color="success"
                    v-if="$store.getters.retrieveOrderDiscountsEnabled == '1'"
                  >
                    check_circle_outline
                  </v-icon>
                  <v-icon left color="error" v-else>cancel</v-icon>
                </div>
              </template>
            </v-switch>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      orders_discounts_flag: this.$store.getters.retrieveOrderDiscountsEnabled,
    };
  },

  computed: {},

  methods: {
    ...mapActions(["setOrderDiscountsEnabledFlag"]),

    async setFlag() {
      console.log("SET");
      console.log(this.orders_discounts_flag);
      let result = await this.setOrderDiscountsEnabledFlag(
        this.orders_discounts_flag ? 1 : 0
      );

      if (result) {
        this.dialog = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>